/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';
import { formPropTypes } from 'redux-form';


export const lookupStatusPropType = PropTypes.oneOf(['matched', 'unmatched', 'reference']);


export const lookupJoinTypePropType = PropTypes.oneOf(['user_records', 'lookup_records', 'union']);


export const nodeType = PropTypes.shape({
  id: PropTypes.number.isRequired,
});


export const fileType = PropTypes.shape({
  name: PropTypes.string.isRequired,
});


export const routerProps = {
  match: PropTypes.any.isRequired,
  location: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
  staticContext: PropTypes.any,
};


export const fieldProps = {
  input: PropTypes.any,
  meta: PropTypes.any,
};


export const formProps = {
  ...formPropTypes,
  validate: PropTypes.func,
  clearFields: PropTypes.any.isRequired,
  clearSubmitErrors: PropTypes.any.isRequired,
};
